import type { UppyFileType } from 'src/app/shared/components/imageUpload';

export function handlePhotoFile(file: UppyFileType, onImageChange: (image: string) => void): void {
	const reader = new FileReader();

	// Required for Safari/iOS FileReader reliability - handler must be registered before read
	reader.onerror = () => {
		// eslint-disable-next-line no-console
		console.error('[imageUpload] FileReader error', reader.error);
	};

	reader.onload = () => {
		// reader.result should be a string due to use of reader.readAsDataURL()
		if (typeof reader.result !== 'string') return;
		onImageChange(reader.result);
	};
	// file.data can be Blob, File, or { size: number | null } - we only want to read actual blobs/files
	if (file.data instanceof Blob) {
		reader.readAsDataURL(file.data);
	}
}
